import { noop } from 'lodash';

import { ReceptionServiceWithPractitioners } from '@dreryk/egabinet-private-medical-service-frontend-api';

import { Checkbox } from '@dreryk/react-components';

import { receptionServiceTranslationKeys } from '../../../../../translations';
import { PractitionerReceptionServiceUpdateFormBean } from '../../../../update/practitioner/PractitionerReceptionServiceUpdateForm';
import { ReceptionServiceFormController } from '../../ReceptionServiceForm';

import { AsFree, WithPrice, WithPriceRange } from './receptionServicePrice.types';
import { mapReceptionServicePriceToBean } from './receptionServicePrice.utils';

type ReceptionServiceUseDefaultConfigurationCheckboxProps = Pick<
   ReceptionServiceFormController,
   'register' | 'setValue'
> & {
   readonly receptionService: ReceptionServiceWithPractitioners;
};

export const ReceptionServiceUseDefaultConfigurationCheckbox = (
   props: ReceptionServiceUseDefaultConfigurationCheckboxProps
): JSX.Element => {
   const handleSelectionChange = (checked: boolean): void => {
      if (checked) {
         props.setValue<keyof PractitionerReceptionServiceUpdateFormBean>(
            'estimatedDuration',
            props.receptionService.estimatedDuration.asMinutes(),
            {
               shouldValidate: true,
            }
         );

         return Object.entries(
            mapReceptionServicePriceToBean(props.receptionService)
         ).forEach(([key, value]: [string, AsFree | WithPrice | WithPriceRange]) =>
            props.setValue(key, value, { shouldValidate: true })
         );
      }

      return noop();
   };

   return (
      <Checkbox
         testId={'usingDefaultConfiguration'}
         label={receptionServiceTranslationKeys.shared.form.components.generalPriceCheckbox.label}
         controller={props.register('usingDefaultConfiguration')}
         onSelectionChange={handleSelectionChange}
      />
   );
};
